// extracted by mini-css-extract-plugin
export default {"root":"Billing_root__7bir8"};